import { useEffect, useRef } from "react";

const MAX_GAP = 50;
const MIN_LEN = 3;

export const isEditable = (el) => !!el && (el.isContentEditable || ["INPUT", "TEXTAREA", "SELECT"].includes(el.tagName));

// Detects keyboard-wedge scanner bursts (fast keystrokes ending with Enter).
// Focused fields keep the scanned text (Enter is swallowed); fields marked data-scan-capture route the scan to onScan.
export function useKeyboardScanner(onScan, enabled = true) {
  const ref = useRef(onScan);
  ref.current = onScan;

  useEffect(() => {
    if (!enabled) return;
    let buf = "";
    let last = 0;
    let slowest = 0;
    const onKey = (e) => {
      if (e.ctrlKey || e.altKey || e.metaKey) return;
      const now = performance.now();
      const gap = now - last;
      last = now;
      if (e.key === "Enter") {
        const code = buf.trim();
        const fast = Math.max(slowest, gap) <= MAX_GAP;
        buf = "";
        slowest = 0;
        if (code.length < MIN_LEN || !fast) return;
        e.preventDefault();
        e.stopPropagation();
        const el = document.activeElement;
        if (isEditable(el) && el.dataset.scanCapture !== "true") return;
        ref.current(code);
        return;
      }
      if (e.key.length !== 1) return;
      if (gap > MAX_GAP) { buf = e.key; slowest = 0; } else { buf += e.key; slowest = Math.max(slowest, gap); }
    };
    window.addEventListener("keydown", onKey, true);
    return () => window.removeEventListener("keydown", onKey, true);
  }, [enabled]);
}
